import React from 'react';
import { Input, Button, TableContainer } from 'hrone-react';
import { observer } from 'mobx-react';
import LoginComponent from './login/index';
import ForgetComponent from './forget/index';
import RegisterComponent from './register/index';
import store from './main.store';
import './main.less';
@observer
class Main extends React.PureComponent {
    constructor(props: any) {
        super(props)
        store.getAreaCodeOptions();
    }
    render() {
        return (
            <div className="login-main">
                <div className="bg-wrapper">
                    <div className="bg">
                        <span>Log in to Gaia Kiosk</span>
                    </div>
                </div>
                <Choose>
                    <When condition={!store.isShowRegister && !store.isShowResetPassword}>
                        <LoginComponent />
                    </When>
                    <When condition={store.isShowRegister && !store.isShowResetPassword}>
                        <RegisterComponent />
                    </When>
                    <Otherwise>
                        <ForgetComponent />
                    </Otherwise>
                </Choose>
            </div>
        );
    }
}

export default Main;
